export default {"src":"/_next/static/media/security-icon.be704c14.svg","height":42,"width":32};